import * as z from "zod";
import type { TFunction } from "i18next";

import { EMPTY_INSPECTION_FILTERS } from "../utils/inspectionFilters";

/** Filtro da listagem: nenhum campo é obrigatório. `undefined`/`null` do DS vira `""`. */
const optionalFilterText = z
  .string()
  .nullish()
  .transform((value) => value ?? "");

export const createInspectionFilterSchema = (t: TFunction) =>
  z
    .object({
      inspectionCode: optionalFilterText,
      responsibleName: optionalFilterText,
      dateFrom: optionalFilterText,
      dateTo: optionalFilterText,
      inspectionStatus: optionalFilterText,
      creationOrigin: optionalFilterText,
      hasAnomalies: optionalFilterText,
    })
    .refine(
      (data) => !data.dateFrom || !data.dateTo || data.dateFrom <= data.dateTo,
      {
        path: ["dateTo"],
        message: t("inspection.filters.dateRangeInvalid"),
      },
    );

export type InspectionFilterFormData = z.infer<
  ReturnType<typeof createInspectionFilterSchema>
>;

export const inspectionFilterDefaults = EMPTY_INSPECTION_FILTERS;
